import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableReturnInsuranceSettings = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableReturnInsuranceSettings);
};
